export enum WidgetName {
  BirthdayList = 'Birthdays',
  UpcomingReviews = 'Reviews',
  ClientSpecialOccasions = 'Client Special Occasions',
  PerformanceOverview = 'Performance Overview',
  ClientTypeAnalysis = 'Client Type Analysis',
  JeanetteMarais = 'Jeanette Marais',
  BigCombo = 'Big Combo',
  PendingServiceAgreements = 'Pending/Rejected Service Agreements',
  Leads = 'Leads to follow up',
}